export default __webpack_public_path__ + "static/media/project3-ipad.a605ffd3.png";